import { required, Validator } from '@/entities/validation';
import { LegacyRecordEditable } from '@/ui/pages/issue/legacyTypes';
import { IssueLegacy } from '@/ui/pages/checklist/adaptors/IssueAdaptors';

export const validate: Validator<LegacyRecordEditable> = todo => [
  ...required(todo.title, 'title'),
];

export const buildValidatorInspectionIssue: Validator<IssueLegacy> = issue => {
  const validators = [];

  if (issue.settings.title_required) {
    validators.push(...required(issue.params.title ?? '', 'title'));
  }

  if (issue.settings.description_required) {
    validators.push(...required(issue.params.description ?? '', 'description'));
  }

  if (issue.settings.assignees_required) {
    validators.push(...required(
      issue.params.assignees.users.concat(issue.params.associateAssignees).concat(issue.params.assignees.groups),
      'assignees',
    ));
  }

  return validators;
};
